(function() {
    'use strict';

    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var SPLIT_REGEX = /(\s|,|;|<|>)+/;
    var PUNCTUATION_CHARS = /(\?|\.|!|'|"|`)*$/g;

    angular.module('GorillaBoy.services')
    .factory('DocumentUtilities', [
        '$rootScope',
        'SignalProvider',
        'DocumentStateService',
        'AppConstants',
        '$translate',
        '$log',
        DocumentUtilities
    ]);

    // This utilities class serves functions common to document directives, services, controller.
    function DocumentUtilities($rootScope, SignalProvider, DocumentStateService, AppConstants, $translate, $log) {
        var documentUtilities = {},
            globalRoles = AppConstants.GlobalRoles,
            feedbackTypes = AppConstants.FeedbackTypes;


        /**
         * Converts an S3 URL to use https://s3.amazonaws.com/ Domain URL with path based bucketName.
         *
         * @param s3Url S3 URL which contains bucket name in the domain part of the URL.
         * @return Converted S3 URL which now contains the bucket name in the path instead of the domain name.
         */
        documentUtilities.convertS3UrlToUsePathBasedBuckets = function(s3Url) {
            if (!s3Url) {
                return s3Url;
            }
            if (!s3Url.startsWith("https://") || s3Url.startsWith("https://s3.amazonaws.com/")) {
                //We deal with only HTTPS URL and URLs with domain based bucket names
                return s3Url;
            }
            var lengthOfPrefix = "https://".length;
            var idxOfFirstDot = s3Url.indexOf('.', lengthOfPrefix);
            var idxOfFirstSlash = s3Url.indexOf("/", lengthOfPrefix);
            if (idxOfFirstDot === -1 | idxOfFirstSlash === -1) {
                //Invalid URL
                return s3Url;
            }
            var bucketName = s3Url.substring(lengthOfPrefix, idxOfFirstDot);
            var restOfTheUrl = s3Url.substring(idxOfFirstSlash + 1);
            return "https://s3.amazonaws.com/" + bucketName + "/" + restOfTheUrl;
        };

        documentUtilities.roleToHumanString = function (role) {
            //Undefined role causes too many error messages in Preview website
            if (!role) {
                return "";
            }
            switch (role) {
                case globalRoles.VIEWER:
                    return $translate.instant('RIGHT_NAV.VIEWER');
                case globalRoles.CONTRIBUTOR:
                    return $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                case globalRoles.COOWNER:
                    return $translate.instant('RIGHT_NAV.CO_OWNER');
                case globalRoles.OWNER:
                    return $translate.instant('RIGHT_NAV.OWNER');
                default:
                    $log.error("Role string does not appear to be valid, Recevied : " + role);
                    return ""; //Since this method is intended for building human readable description,
                                // we should not return null as it'll be displayed as "null"
            }
        };

        documentUtilities.parseTextAndReturnEmails = function(inputText, dedupeList) {
            var emailsList = [];
            if (dedupeList === undefined) {
                dedupeList = true;
            }
            //http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
            inputText.split(SPLIT_REGEX).forEach(function(word) {
                //Let's also trim if there are any extra unicode chars left
                word = word.trim();
                word = word.replace(PUNCTUATION_CHARS, '');
                if (EMAIL_REGEX.test(word)) {
                    emailsList.push(word);
                }
            });
            //In case of DL lists the email label will be exactly the same as the email itself hence take unique values
            if (dedupeList) {
                emailsList = _.uniq(emailsList);
            }
            return emailsList;
        };

        documentUtilities.parseTextAndEmbedMarkdownForEmails = function(text) {
            //We don't want to dedupe lists in this case because we want to highlight all the emails
            var emails = this.parseTextAndReturnEmails(text, false);
            var searchStartIdx = 0;
            emails.forEach(function(email) {
                var idx = text.indexOf(email, searchStartIdx);
                if (idx !== -1) {
                    text = text.substring(0, idx) + '`' + email + '`' + text.substring(idx + email.length);
                    searchStartIdx = idx + email.length + 2; //for the two ticks we're adding
                }
            });
            return text;
        };

        documentUtilities.getLatestVersionId = function(documentVersions) {
            var sortedVersions = _.sortBy(documentVersions, 'Created');
            return sortedVersions[sortedVersions.length - 1].VersionId;
        };
        documentUtilities.getLatestNonDraftVersionId = function(documentVersions) {
            var sortedVersions = _.sortBy(documentVersions, 'Created');
            var i,
                resultVersion,
                length = sortedVersions.length;

            //Iterate in reverse to find out the latest non-draft version
            for (i = length - 1 ; i >= 0 ; i--) {
                if (!resultVersion) {
                    if (sortedVersions[i].VersionStatus !== AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) {
                        resultVersion = sortedVersions[i];
                    }
                } else {
                    break;
                }
            }
            return resultVersion.VersionId;
        };

        documentUtilities.getAnnotationObjectFromId = function(feedbackListMap, annotationId) {
            var resultFeedbackObj = null;
            angular.forEach(feedbackListMap, function(feedbackSections) {
                if (resultFeedbackObj) {
                    return;
                }
                feedbackSections.some(function(feedbackSection) {
                    if (feedbackSection.title !== AppConstants.DOC_LEVEL) {
                        return feedbackSection.some(function(feedbackObjInner) {
                            if (feedbackObjInner.AnnotationId === annotationId) {
                                resultFeedbackObj = feedbackObjInner;
                                return true;
                            } else if (feedbackObjInner.Replies) {
                                return feedbackObjInner.Replies.some(function(replyObj) {
                                    if (replyObj.AnnotationId === annotationId) {
                                        resultFeedbackObj = replyObj;
                                        return true;
                                    }
                                });
                            }
                        });
                    }
                });
            });
            return resultFeedbackObj;
        };

        documentUtilities.getCommentObjectFromId = function(feedbackListMap, commentId) {
            var resultFeedbackObj = null;
            angular.forEach(feedbackListMap, function(feedbackSections) {
                if (resultFeedbackObj) {
                    return;
                }
                feedbackSections.some(function(feedbackSection) {
                    if (feedbackSection.title === AppConstants.DOC_LEVEL) {
                        return feedbackSection.some(function(feedbackObjInner) {
                            if (feedbackObjInner.CommentId === commentId) {
                                resultFeedbackObj = feedbackObjInner;
                                return true;
                            } else if (feedbackObjInner.Replies) {
                                return feedbackObjInner.Replies.some(function(replyObj) {
                                    if (replyObj.CommentId === commentId) {
                                        resultFeedbackObj = replyObj;
                                        return true;
                                    }
                                });
                            }
                        });
                    }
                });
            });
            return resultFeedbackObj;
        };

        documentUtilities.compareHighlightPosition = function(feedbackObj, feedbackObjToInsert) {
            if (feedbackObj.Regions && feedbackObj.Regions.length > 0) {
                var feedbackObjTLX = feedbackObj.Regions[0].TopLeft.X;
                var feedbackObjTLY = feedbackObj.Regions[0].TopLeft.Y;
                var feedbackObjToInsertTLX = feedbackObjToInsert.Regions[0].TopLeft.X;
                var feedbackObjToInsertTLY = feedbackObjToInsert.Regions[0].TopLeft.Y;
                if (feedbackObjTLY < feedbackObjToInsertTLY) {
                    return -1;
                } else if (feedbackObjTLY > feedbackObjToInsertTLY) {
                    return 1;
                } else {
                    if (feedbackObjTLX <= feedbackObjToInsertTLX) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
            }
        };

        documentUtilities.feedbackSectionComparator = function(feedbackSectionA, feedbackSectionB) {
            return feedbackSectionA.marker - feedbackSectionB.marker;
        };

        documentUtilities.feedbackRepliesComparator = function(replyA, replyB) {
            return replyA.Created > replyB.Created ? 1 : (replyA.Created < replyB.Created ? -1 : 0);
        };

        documentUtilities.hideFeedbackInput = function() {
            $rootScope.$broadcast(SignalProvider.FeedbackInput.Hide);
        };

        documentUtilities.isAnnotationInput = function(feedbackObject) {
            return feedbackObject && feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_INPUT;
        };

        documentUtilities.isResolved = function(feedbackObject) {
            return feedbackObject.ResolutionInfo && feedbackObject.ResolutionInfo.ResolutionStatus === AppConstants.FEEDBACK_RESOLUTION_STATUS.RESOLVED;
        };

        documentUtilities.isUnresolved = function(feedbackObject) {
            return !documentUtilities.isResolved(feedbackObject);
        };

        documentUtilities.isComment = function(feedbackObject) {
            return !!(feedbackObject && feedbackObject.CommentId);
        };

        documentUtilities.isAnnotation = function(feedbackObject) {
            return !!(feedbackObject && feedbackObject.AnnotationId);
        };

        documentUtilities.isDraft = function(feedbackObject) {
            if (feedbackObject) {
                if (documentUtilities.isComment(feedbackObject)) {
                    return feedbackObject.CommentStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT;
                }
                return feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT;
            }
            return false;
        };

        documentUtilities.isPublished = function(feedbackObject) {
            if (feedbackObject) {
                if (documentUtilities.isComment(feedbackObject)) {
                    return feedbackObject.CommentStatus === feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
                }
                return feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
            }
            return false;
        };

        documentUtilities.isPublishedDeleted = function(feedbackObject) {
            if (feedbackObject) {
                if (documentUtilities.isComment(feedbackObject)) {
                    return feedbackObject.CommentStatus === feedbackTypes.FEEDBACK_TYPE_DELETED;
                }
                return feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DELETED;
            }
            return false;
        };

        documentUtilities.getFeedbackMetadata = function(feedbackObj) {
            if (!feedbackObj) {
                return null;
            }

            // Common to feedback drawn and feedback
            var id = null;
            if (documentUtilities.isAnnotation(feedbackObj)) {
                id = feedbackObj.AnnotationId;
            } else if (documentUtilities.isComment(feedbackObj)) {
                id = feedbackObj.CommentId;
            }

            if (!DocumentStateService.feedbackMetadata[id]) {
                DocumentStateService.feedbackMetadata[id] = {};
            }
            DocumentStateService.feedbackMetadata[id].obj = feedbackObj;
            return DocumentStateService.feedbackMetadata[id];
        };

        documentUtilities.isQuartzDocument = function(document) {
            return document && document.VersionMetadata && document.VersionMetadata.ContentType === "application/quartz";
        }

        return documentUtilities;
    }

}());
